const Button = ({ onClick, text, color, disabled }) => {
  return (
    <button
      className={`button mobile:text-base small:text-lg desktop:text-2xl font-body 
        mobile:px-[42px] mobile:py-4 small:px-[95px] small:py-3 desktop:px-40 desktop:py-5 
        rounded-sm drop-shadow-md border-green shadow-green text-white 
        ${color === "red" ? "bg-gradient-red" : "bg-gradient-green"} ${
        disabled ? "opacity-50" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
